<form [formGroup]="formDescription">
  <div class="form-group row">
    <label for="kaizenTitle" class="col-sm-3 p-1 col-form-label-textbox-center">Kaizen Name *</label>
    <div class="col-sm-8 p-1">
      <input type="text" class="form-control" formControlName="kaizenTitle" id="kaizenTitle"
        placeholder="Kaizen Name" (keyup)="titleKeyUp($event)">

        @if (((formDescription.get('kaizenTitle')?.touched ) && formDescription.get('kaizenTitle')?.errors?.required)) {
          <small class="invalid"
          >Kaizen name is required</small>
        }
        @if (formDescription.get('kaizenTitle')?.errors?.['maxlength']) {
          <small class="invalid"
            >Kaizen Name maximum length is 200 characters
          </small>
        }
      </div>
    </div>


    <div class="form-group row">
      <label for="kaizenDescription" class="col-sm-3 p-1 col-form-label">Brief Description (used for Obeya
      Report) *</label>
      <div class="col-sm-8 p-1">
        <textarea class="form-control" formControlName="kaizenDescription" name="kaizenDescription" id="kaizenDescription"
        placeholder="Brief Description" rows="3" class="form-control" (keyup)="descriptionKeyUp($event)"></textarea>
        @if (((formDescription.get('kaizenDescription')?.touched) && formDescription.get('kaizenDescription')?.errors?.['required'])) {
          <small class="invalid"
            >Brief
            Description is required field
          </small>
        }
        @if (formDescription.get('kaizenDescription')?.errors?.['maxlength']) {
          <small class="invalid"
            >Brief Description (used for Obeya
            Report) maximum length is 2000 characters
          </small>
        }

      </div>
    </div>
    <div class="form-group row">
      <label for="kaizenAdditionalComments" class="col-sm-3 p-1 col-form-label">Include in Cost Obeya?</label>

      <label class="switch"><input id="includeCostInObeya" formControlName="includeCostInObeya" type="checkbox" (change)="includeCostInObeyaChecked($event)">
        <span class="slider round"></span></label>
        <label for="includeCostInObeya"  class="slider-label">{{includeCostInObeyaYesNo}}</label>
      </div>
      @if (includeCostInObeyaYesNo=='Yes') {
        <div class="form-group row">
          <label for="isBOD" class="col-sm-3 p-1 col-form-label" style="padding-top: 8px!important;">BOD</label>
          <label class="switch"><input id="isBOD" formControlName="isBOD" type="checkbox" (change)="isBODChecked($event)">
            <span class="slider round"></span></label>
            <label for="isBOD"  class="slider-label">Unplanned</label>
          </div>
        }
        <div class="form-group row">
          <label for="internalTrackingNo" class="col-sm-3 p-1 col-form-label-textbox-center">Internal Tracking Number</label>
          <div class="col-sm-8 p-1">
            <input type="text" class="form-control" formControlName="internalTrackingNo" id="internalTrackingNo" maxlength="10"
              placeholder="Internal Tracking Number" (keyup)="internalTrackingNoKeyUp($event)">
            </div>
          </div>
          <div class="form-group row">
            <label for="trackingRef1" class="col-sm-3 p-1 col-form-label-textbox-center">Tracking Ref1</label>
            <div class="col-sm-8 p-1">
              <input type="text" class="form-control" formControlName="trackingRef1" id="trackingRef1" maxlength="10"
                placeholder="Tracking Ref1" (keyup)="trackingRef1KeyUp($event)">
              </div>
            </div>
            <div class="form-group row">
              <label for="trackingRef2" class="col-sm-3 p-1 col-form-label-textbox-center">Tracking Ref2</label>
              <div class="col-sm-8 p-1">
                <input type="text" class="form-control" formControlName="trackingRef2" id="trackingRef2" maxlength="10"
                  placeholder="Tracking Ref2" (keyup)="trackingRef2KeyUp($event)">
                </div>
              </div>

              <div class="form-group row">
                <label for="kaizenAdditionalComments" class="col-sm-3 p-1 col-form-label">Additional Comments:</label>
                <div class="col-sm-8 p-1">
                  <textarea class="form-control" formControlName="kaizenAdditionalComments" name="kaizenAdditionalComments" id="kaizenAdditionalComments"
                  placeholder="Additional Comments" rows="3" class="form-control" (keyup)="additionalCommentsKeyUp($event)"></textarea>
                  @if (formDescription.get('kaizenAdditionalComments')?.errors?.['maxlength']) {
                    <small class="invalid"
                      >Additional Comments maximum length is 2000 characters
                    </small>
                  }
                </div>
              </div>

            </form>


